import { SxProps, Theme } from '@mui/material';
import { atlasSemantic } from 'src/theme/atlas/tokens';

export const tableContainer: SxProps<Theme> = {
  border: `1px solid ${atlasSemantic.color.ui.divider.default}`,
  borderRadius: `${atlasSemantic.radius.md}`,
};

export const table: SxProps<Theme> = { minWidth: 1200 };

export const headerRow: SxProps<Theme> = {
  backgroundColor: atlasSemantic.color.action.secondary.hoverFill,
};

export const cell: SxProps<Theme> = { whiteSpace: 'nowrap' };

export const clickableCell: SxProps<Theme> = {
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  fontWeight: 700,
  textDecoration: 'underline',
};

export const actionCell: SxProps<Theme> = {
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  justifyContent: 'flex-end',
};

export const headerCell: SxProps<Theme> = {
  fontWeight: 700,
  whiteSpace: 'nowrap',
};

export const row: SxProps<Theme> = {};
